/**
 * Sticky
 * ======================================
 * - jquery needed
 */

let enable = window.outerWidth > 1

if (enable) {

	var initSticky = function() {
		var $el = $('.js-sticky')

		$el.each(function(){
			var $placeholder = $($(this).attr('data-placeholder'))

			if($placeholder.length){
				$placeholder.height($el.outerHeight())
			}
		})
	}

	var resetSticky = function() {
		var $el = $('.js-sticky')

		$el.each(function(){
			var $this = $(this)

			$this.removeAttr('data-init')
			$this.removeAttr('data-top')
			$this.removeAttr('data-left')
			$this.removeAttr('style')
		})


	}

	var scrollEvent = function() {
		var top = window.scrollY
		var $el = $('.js-sticky')

		$el.each(function(){
			var $this = $(this)
			var $placeholder = $($this.attr('data-placeholder'))
			var $parent = $this.closest('.js-sticky-parent')

			if(!$parent.length){
				var $parent = $('body')
			}

			if(!$this.attr('data-init')){
				var elTop = $this.offset().top
				var elLeft = $this.offset().left

				$this.attr('data-init', true)
				$this.attr('data-top', elTop)
				$this.attr('data-left', elLeft)
			}else{
				var elTop = $this.attr('data-top')
				var elLeft = $this.attr('data-left')
			}

			var stickyTop = $this.attr('data-offset') ? parseInt($this.attr('data-offset')) : 0
			var stickyBottom = $parent.outerHeight() + $parent.offset().top - $this.outerHeight()

			if($placeholder.length){
				$placeholder.removeClass('hide')
			}

			if(top >= stickyBottom - stickyTop){
				$this.css({"left": elLeft+'px', "top": stickyBottom - top, "position": 'fixed'})
			}else if(top >= elTop - stickyTop){
				$this.css({"left": elLeft+'px', "top": stickyTop, "position": 'fixed'})
			}else{
				$this.removeAttr('style').removeClass('is-sticky')

				if($placeholder.length){
					$placeholder.addClass('hide')
				}
			}

			// console.log(top, elTop, elLeft, stickyBottom)


		})


	}

	window.addEventListener('scroll', function() {
		window.requestAnimationFrame(scrollEvent)
	});

	if(window.attachEvent) {
	    window.attachEvent('onresize', resetSticky);
	    window.attachEvent('onresize', scrollEvent);
	}
	else if(window.addEventListener) {
	    window.addEventListener('resize', resetSticky, true);
	    window.addEventListener('resize', scrollEvent, true);
	}
	else {
	    //The browser does not support Javascript event binding
	}


	// initial call
	scrollEvent()
	initSticky()

}
